<template>
  <div>
    <PageHeaderLayout>
      <el-tabs v-model="activeTab"
        @tab-click="handleTabClick"
        :before-leave="beforeSwitch"
        tab-position="left"
        type="card">
        <div class="tab-pane-header">
          {{hearTitle}}
          <el-button class="return-list" size="medium" type="primary" icon="iconfont icon-fanhui8" @click="returnList">返回列表</el-button>
        </div>
        <el-tab-pane label="基本信息" v-loading="loadingStatus" :element-loading-text="loadingText">
          <BasicInfo ref="basicInfoVue" :goodsInfo="formData" @formSubmit="basicInfoFormSubmit" v-if="flag && activeTab == 0"></BasicInfo>
        </el-tab-pane>
        <el-tab-pane label="规格/库存" v-loading="loadingStatus" :element-loading-text="loadingText">
          <SpecStock ref="SpecStockVue" :goodsInfo="formData" @formSubmit="specStockFormSubmit" v-if="flag && activeTab == 1"></SpecStock>
        </el-tab-pane>
        <el-tab-pane label="商品详情" v-loading="loadingStatus" :element-loading-text="loadingText">
          <GoodsIntro ref="GoodsIntroVue" :goodsInfo="formData" @formSubmit="goodsIntroFormSubmit" v-if="flag && activeTab == 2"></GoodsIntro>
        </el-tab-pane>
        <el-tab-pane label="其它设置" v-loading="loadingStatus" :element-loading-text="loadingText">
          <OtherSet ref="OtherSetVue" :goodsInfo="formData" @formSubmit="otherSetFormSubmit" v-if="flag && activeTab == 3"></OtherSet>
        </el-tab-pane>
        <el-tab-pane label="优惠设置" v-loading="loadingStatus" :element-loading-text="loadingText">
          <DiscountsSet ref="DiscountsSetVue" :goodsInfo="formData" @formSubmit="discountsSetFormSubmit" v-if="flag && activeTab == 4"></DiscountsSet>
        </el-tab-pane>
        <div class="tab-pane-footer"  v-if="paneFooterStatus" >
          <el-button size="medium" type="primary" :disabled="loadingStatus" @click="saveConfirm">保存</el-button>
        </div>
      </el-tabs>
    </PageHeaderLayout>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeButton from '@/components/ApeButton'
import BasicInfo from './BasicInfo'
import SpecStock from './SpecStock'
import GoodsIntro from './GoodsIntro'
import OtherSet from './OtherSet'
import DiscountsSet from './DiscountsSet'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeButton,
    BasicInfo,
    SpecStock,
    GoodsIntro,
    OtherSet,
    DiscountsSet
  },
  // 定义属性
  data() {
    return {
      activeTab: 0,
      hearTitle: '基本信息',
      loadingText: '玩命加载中……',
      flag: false, // 是否加载子组件标志
      goodsId:0, // 商品id，0表示创建，非零为编辑
      // 商品基本信息表单结构
      formData: {}  
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters(['userPermissions','buttonType','loadingStatus']),
    // 商品相关信息处理窗格，页脚是否显示
    paneFooterStatus() {
      if (parseInt(this.activeTab) > 4) {
        return false
      }
      return true
    }
  },
  // 方法集合
  methods: {
    handleTabClick(tab) {
      if (this.goodsId === 0 && tab.index !== '0') {
        return false
      }      
      this.hearTitle = tab.label
    },
    // tab标签切换前调用,activeName, oldActiveNam
    beforeSwitch(active) {
      // 创建商品是，只允许操作“基本设置”
      if (this.goodsId === 0 && active !== '0') {
        this.$notify.warning('请完成当前设置！')
        return false
      }
    },
    // 返回列表按钮
    returnList() {
      this.$router.push('/goods')
    },
    // 初始化商品基本信息
    async initGoodsInfo() {
      if (this.$route.params.goods_id) {
        this.goodsId = this.$route.params.goods_id
      }
      if (this.goodsId) {
        let {info} = await this.$api.getGoodsInfo(this.goodsId)
        this.formData = info
      }
      this.flag = true
    },
    // 确认保存按钮
    saveConfirm() {
      if (parseInt(this.activeTab) === 0) {
        this.$refs['basicInfoVue'].formValidate()
        return true
      }
      if (parseInt(this.activeTab) === 1) {
        this.$refs['SpecStockVue'].formValidate()
        return true
      }
      if (parseInt(this.activeTab) === 2) {
        this.$refs['GoodsIntroVue'].formValidate()
        return true
      }
      if (parseInt(this.activeTab) === 3) {
        this.$refs['OtherSetVue'].formValidate()
        return true
      }
      if (parseInt(this.activeTab) === 4) {
        this.$refs['DiscountsSetVue'].formValidate()
        return true
      }
    },
    // 商品相关信息的保存处理
    async formSubmit() {
      this.$store.commit('changeLoadingStatus',true)
      let id = await this.$api.saveGoods(this.formData)
      if (id) {
        this.$notify.success('保存成功！')
      }
      if (this.goodsId === 0 && id) {
        this.$router.push({path:`${this.$route.matched[1].path}/${id}/edit`})
        this.initGoodsInfo()
      }
      if ( parseInt(this.activeTab) < 4 ) {
        this.activeTab = String(parseInt(this.activeTab)+1)
      }
      this.$nextTick(() => {
        this.$store.commit('changeLoadingStatus',false)
      }) 
    },
    // 基本设置表单提交
    basicInfoFormSubmit(data) {
      this.formData = data
      this.formSubmit()
    },
    // 规格库存表单提交
    async specStockFormSubmit(data) {
      this.formData = data
      await this.formSubmit()
      await this.initGoodsInfo()
    },
    // 商品详情表单提交
    goodsIntroFormSubmit(data) {
      this.formData = data
      this.formSubmit()
    },
    // 其它设置
    otherSetFormSubmit(data) {
      this.formData = data
      this.formSubmit()
    },
    // 优惠设置
    discountsSetFormSubmit(data) {
      this.formData = data
      this.formSubmit()
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$store.commit('changeLoadingStatus',true)
    this.initGoodsInfo()
    this.$nextTick(() => {
      this.$store.commit('changeLoadingStatus',false)
    })  
  }
}
</script>

<style lang='stylus'>
  .el-tabs--left 
    .el-tabs__header.is-left
      margin-left 16px
      margin-right 40px
      min-width 160px
  .el-tabs__nav.is-left
    background-color #ffffff
    border-radius 4px !important
    overflow hidden
  .el-tabs--left.el-tabs--card
    .el-tabs__nav
      border-right 1px solid #e4e7ed
      border-bottom none 
    > .el-tabs__header
      border-bottom none 
    .el-tabs__item.is-left
      border-right none !important
      text-align center
    .el-tabs__item.is-left.is-active
      background-color #179aff
      color #ffffff
  .el-tabs--left > .el-tabs__content
    background-color #ffffff
    min-height 640px
    box-shadow 0 1px 4px rgba(0,21,41,.08)
    border-radius 4px
    position relative
    transition all .3s
    font-size 14px
    .tab-pane-header
      border-bottom 1px solid #e8e8e8
      margin-bottom -1px
      min-height 48px
      line-height 48px
      padding 0 16px
      font-size 14px
  .tab-pane-body-live
    padding 16px
    .body-header
      min-height 48px
      border-bottom 1px dashed #e8e8e8
    .body-content
      margin 16px 16px 0px 16px
    .el-tree-node__content
      margin-bottom 0px !important
  .tab-pane-footer
    min-height 48px
    line-height 48px
    border-top 1px solid #e8e8e8
    padding-left 128px
    width 100%
    position absolute
    bottom 0px
  .el-radio
    margin-right 0px
  .el-radio.is-bordered
    width 100px
  .el-notification__content
    margin-top 2px
  .return-list
    float right
    margin-top 8px
  .el-tabs .el-button i
    margin-right 4px
  .el-tree-node__content
    height 24px
  .el-tree > .el-tree-node.is-focusable > .el-tree-node__content
    border-radius 4px
    margin-bottom 8px
    padding 8px !important
    overflow hidden
    background #d9edf7
    border-left 6px solid #bce8f1
    border-right 6px solid #bce8f1
  .el-tree-node__content:hover
    background-color #d9edf7
  .el-tree > .el-tree-node.is-focusable > .el-tree-node__children
    padding-left 32px
    margin-bottom 12px
  .el-tree-node__children > .el-tree-node.is-focusable 
    margin-bottom 8px
    > .el-tree-node__content
      background #f3f3f4
      border-left 6px solid #e7eaec
      border-right 6px solid #e7eaec
      border-radius 4px
      padding 8px !important
      overflow hidden
  .success-status-tag
    background-color #1c84c6
    color #FFFFFF
    border-radius 10px
    padding 2px 8px
  .warning-status-tag
    background-color #e6a23c
    color #FFFFFF
    border-radius 10px
    padding 2px 8px

</style>